<div class="topology-device__wrapper">
  <div class="topology-device__content">
    <span class="topology-device__image">
      <ng-container [ngSwitch]="name">
        <img *ngSwitchCase="RemoteDeviceType.CS" src="assets/icons/zigbee/cs.svg" />
        <img *ngSwitchCase="RemoteDeviceType.REPEATER" src="assets/icons/zigbee/repeater.svg" />
        <img *ngSwitchCase="RemoteDeviceType.FHT" src="assets/icons/zigbee/repeater.svg" />
        <img *ngSwitchCase="RemoteDeviceType.TRV" src="assets/icons/zigbee/trv.svg" />
        <img *ngSwitchDefault src="assets/icons/zigbee/vitoconnect.svg" />
      </ng-container>
    </span>
    <span class="topology-device__details">
      <span class="topology-device__business-name">
        {{ businessName | dash }}
      </span>
      <span *ngIf="gatewayId" class="topology-device__id">
        {{ '+INSTALLATIONS.SRC.ID' | translate }}
        {{ gatewayId }}
      </span>
      <span *ngIf="displayName" class="topology-device__id">
        {{ '+INSTALLATIONS.SRC.ID' | translate }}
        {{ displayName | serialSpacing }}
      </span>
      <span *ngIf="connectionStatus" class="topology-device__desc">
        {{ '+INSTALLATIONS.SRC.STATUS' | translate }}:
        {{ connectionStatus | translateDeviceStatus }}
      </span>
      <span *ngIf="deviceDescription" class="topology-device__desc">
        {{ '+INSTALLATIONS.SRC.DESC' | translate }}
        {{ deviceDescription }}
      </span>
      <span *ngIf="roomName" class="topology-device__desc">
        {{ '+INSTALLATIONS.SRC.ROOM_NAME' | translate }}:
        {{ roomName }}
      </span>
      <span *ngIf="lqiTotal" class="topology-device__desc">
        {{ ('+INSTALLATIONS.SRC.SIGNAL_STRENGTH.TOTAL_LQI' | translate) + ': ' + lqiTotal + '%' }}
      </span>
      <span *ngIf="rx" class="topology-device__desc">
        {{ ('+INSTALLATIONS.SRC.SIGNAL_STRENGTH.RX' | translate) + ': ' + (rx | percent) }}
      </span>
      <span *ngIf="tx" class="topology-device__desc">
        {{ ('+INSTALLATIONS.SRC.SIGNAL_STRENGTH.TX' | translate) + ': ' + (tx | percent) }}
      </span>
    </span>
  </div>

  <div class="topology__child-devices">
    <ng-content></ng-content>
  </div>
</div>
